import { createContext, useContext, useEffect, useRef } from 'react';
import { captureMessage } from '../../internal/ravenUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const MISSING_PROVIDER_MESSAGE = `[unified-account] mode="headless" was rendered without a \`HeadlessOAuthWindowProvider\` ancestor, so no OAuth popup was supplied. This only happens when \`UnifiedAccountModal\` (or \`UnifiedHeadlessAuthView\`) is rendered directly with mode="headless" — that mode is only supported through the Button / useModal returned by \`buildUnifiedAccount()\`, which wires up the gesture→popup plumbing. Without it the flow will fail with a non-actionable OAuthWindowBlocked error.`;

/**
 * Carries the popup opened on the user gesture by `useHeadlessOAuthLauncher`
 * down to the headless flow, without exposing it as a public prop on the modal
 * components. The popup is internal plumbing; consumers control the flow only
 * through `mode` / `appName`.
 */
const HeadlessOAuthWindowContext = /*#__PURE__*/createContext(undefined);
export function HeadlessOAuthWindowProvider({
  oAuthWindow,
  children
}) {
  return /*#__PURE__*/_jsx(HeadlessOAuthWindowContext.Provider, {
    value: oAuthWindow,
    children: children
  });
}
export function useHeadlessOAuthWindow() {
  const value = useContext(HeadlessOAuthWindowContext);
  const reportedRef = useRef(false);
  useEffect(() => {
    if (value === undefined && !reportedRef.current) {
      reportedRef.current = true;
      captureMessage(MISSING_PROVIDER_MESSAGE);
      console.error(MISSING_PROVIDER_MESSAGE);
    }
  }, [value]);
  return value !== null && value !== void 0 ? value : null;
}